const isEmpty = data => {
  if (typeof (data) === 'number' || typeof (data) === 'boolean') {
    return false
  }
  if (typeof (data) === 'undefined' || data === null) {
    return true
  }
  if (typeof (data.length) !== 'undefined') {
    return data.length === 0
  }

  let count = 0

  for (const i in data) {
    if (data.hasOwnProperty(i)) { // eslint-disable-line
      count++
    }
  }

  return count === 0
}

const isString = value => {
  return typeof value === 'string' || value instanceof String
}

const isFunction = value => {
  return typeof value === 'function'
}

const isObject = value => {
  return value && typeof value === 'object' && value.constructor === Object
}

/**
 * verify if has any empty data in object
 * @param {Object} obj
 * @param {Array} keys
 */
const hasEmpty = (obj, keys) => {
  for (const key of keys || []) {
    if (isEmpty(obj[key])) {
      return true
    }
  }

  return false
}

/**
 * @param {Number} time
 * @returns {Promise>}
 */
const wait = (time = 2000) => {
  return new Promise(resolve => {
    setTimeout(() => resolve(), time)
  })
}

const addToStore = (store, key, value) => {
  store.set(key, value)
  store.keep(key)
}

const removeQueryParamAndAddToStore = (store, key, value, paramToBeRemoved = '', queryParams = {}) => {
  store.set(key, value)
  store.keep(key)
  if (paramToBeRemoved) return removeFromQueryParams(paramToBeRemoved, queryParams)
}

const removeFromQueryParams = (paramToBeRemoved = '', queryParams = {}) => {
  return { query: { ...queryParams, [paramToBeRemoved]: undefined } }
}

const stringMonthToInteger = (month) => {
  switch (month) {
    case 'JAN': return 1
    case 'FEV': return 2
    case 'MAR': return 3
    case 'ABR': return 4
    case 'MAI': return 5
    case 'JUN': return 6
    case 'JUL': return 7
    case 'AGO': return 8
    case 'SET': return 9
    case 'OUT': return 10
    case 'NOV': return 11
    case 'DEZ': return 12
  }
}

export { isEmpty, isString, isFunction, isObject, hasEmpty, wait, removeQueryParamAndAddToStore, removeFromQueryParams, addToStore, stringMonthToInteger }
